import { NormalizedVoucher, FeatureAppStepCitaMode } from '@esportal/portal-service';
import {
	Container,
	ContainerGutter,
	Richtext,
	Text,
	TextAlignment,
	TokenTextAppearance,
	TokenTextColor,
} from '@volkswagen-onehub/components-core';
import * as React from 'react';
import { SalesforceVouchersDetailCtas } from './salesforce-voucher-detail-ctas';
import { normalizeMarkdownForRichtext, createRichtextTextOverrides } from '../../../helpers/common-helpers';

interface Props {
	voucher: NormalizedVoucher;
	handleClickRequestAppointment: (mode: FeatureAppStepCitaMode) => void;
}

export const SalesforceVouchersDetailDataInfo: React.FC<Props> = ({ voucher, handleClickRequestAppointment }) => {
	return (
		<Container wrap="always" horizontalAlign="center">
			<Container gutter={ContainerGutter.dynamic0130} wrap="always" horizontalAlign="center">
				<Text
					textAlign={TextAlignment.center}
					appearance={TokenTextAppearance.headline200}
					color={TokenTextColor.primary}
				>
					<Richtext
						markdown={normalizeMarkdownForRichtext(voucher.card.description ?? '')}
						overrides={createRichtextTextOverrides(TokenTextAppearance.headline200, TokenTextColor.primary)}
					/>
				</Text>

				{voucher.card.modoEmpleo && (
					<Container wrap="always" gutter={ContainerGutter.static200}>
						<Text
							appearance={TokenTextAppearance.headline200}
							color={TokenTextColor.primary}
							textAlign={TextAlignment.center}
							bold
						>
							¿Cómo puedes utilizarlo?
						</Text>
						<Text
							textAlign={TextAlignment.center}
							appearance={TokenTextAppearance.headline200}
							color={TokenTextColor.primary}
						>
							<Richtext
								markdown={normalizeMarkdownForRichtext(voucher.card.modoEmpleo)}
								overrides={createRichtextTextOverrides(TokenTextAppearance.headline200, TokenTextColor.primary)}
							/>
						</Text>
					</Container>
				)}
			</Container>

			<SalesforceVouchersDetailCtas voucher={voucher} handleClickRequestAppointment={handleClickRequestAppointment} />

			{voucher?.legalText && (
				<Text
					textAlign={TextAlignment.center}
					appearance={TokenTextAppearance.copy100}
					color={TokenTextColor.secondary}
				>
					<Richtext
						markdown={normalizeMarkdownForRichtext(voucher.legalText)}
						overrides={createRichtextTextOverrides(TokenTextAppearance.copy100, TokenTextColor.secondary)}
					/>
				</Text>
			)}
		</Container>
	);
};
